var _effectorFileName = "/src/apps/providers/with-i18n.tsx";
import { AppProps } from 'next/app';
import { appWithTranslation } from 'next-i18next';
import nextI18NextConfig from '../../../next-i18next.config.js';

// eslint-disable-next-line react/display-name
export const withI18n = (Component: React.ComponentType<AppProps>) => {
  const WrappedComponent = (props: AppProps) => {
    return <Component {...props} />;
  };
  return appWithTranslation(WrappedComponent, nextI18NextConfig);
};